import { Palette, useModal } from "@homebound/beam";
import { ChangeEventWorkflow } from "src/generated/graphqlTypes";
import { ConfirmationModal } from "src/routes/components/ConfirmationModal";
import { GuidedChangeEventStep } from "src/routes/projects/change-events/guided/utils";
import {
  NotInPrototypeYet,
  reviewImpactStep,
  reviewStep,
} from "src/routes/projects/change-events/guided/workflows/sharedSteps/sharedSteps";
import { defineWorkflow } from "src/routes/projects/change-events/guided/workflows/types";
import { SelectConfigurationStep } from "../1.SelectConfigurationStep";
import {
  applyConfigurationFormConfig,
  ApplyConfigurationFormInput,
  applyConfigurationMapToForm,
} from "../applyConfigurationForm";
import { useApplyConfigurationActions } from "../useSaveApplyConfigurationChangeEvent";
import { ApplyInitialConfigurationGate } from "./components/ApplyInitialConfigurationGate";

export const applyInitialConfigurationWorkflow = defineWorkflow<ApplyConfigurationFormInput>({
  workflow: ChangeEventWorkflow.ApplyInitialConfiguration,
  formConfig: applyConfigurationFormConfig,
  gate: (props) => <ApplyInitialConfigurationGate {...props} />,
  mapToForm: applyConfigurationMapToForm,
  steps: [
    {
      value: GuidedChangeEventStep.SelectConfiguration,
      label: "Select Configuration",
      isComplete: (form) => !!form.selectedConfigId.value && form.proposedReadyPlanOptions.valid,
      render: (form) => <SelectConfigurationStep formState={form} />,
    },
    {
      value: GuidedChangeEventStep.ReviewConfiguration,
      label: "Review Configuration",
      isComplete: () => false,
      disabled: (form) => !form.selectedConfigId.value,
      render: () => <NotInPrototypeYet title="Review Configuration" />,
    },
    reviewImpactStep(),
    reviewStep(),
  ],
  useActions: (args) => {
    const actions = useApplyConfigurationActions(args);
    const { openModal } = useModal();
    return {
      ...actions,
      onSubmit: async () => {
        openModal({
          content: (
            // Show a warning modal before submitting since this is a destructive action
            <ConfirmationModal
              title="Warning: Replace Existing Configuration"
              icon={{ icon: "error", color: Palette.Orange600 }}
              confirmationMessage="Applying a full configuration replaces the project's existing configuration and scopes. Are you sure you want to continue?"
              label="Submit"
              onConfirmAction={actions.onSubmit}
            />
          ),
        });
      },
    };
  },
});
